<template>
  <div class="main-box">
    <i class="fas fa-bell-exclamation" />
    <span>{{ title }} <slot></slot></span>
  </div>
</template>

<script>
export default {
  name: "ServiceWarningBox",
  props: {
    title: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped>
.main-box {
  display: flex;
  background: #fff5e8 0% 0% no-repeat padding-box;
  border: 1px solid #fdac41;
  border-radius: 4px;
  opacity: 1;
  padding: 10px;
  margin-top: 10px;
  margin-left: 14px;
}

.main-box i {
  color: #af6708;
  opacity: 1;
  margin-right: 10px;
  margin-top: 5px;
}

.main-box span {
  text-align: left;
  font: Regular 14px/24px Lato;
  letter-spacing: 0;
  color: #af6708;
  opacity: 1;
}
</style>
